import { useCallback, useMemo } from 'react'
import { ShieldAlert } from 'lucide-react'
import { PageHeader } from '@/shell/AppShell'
import { DataTable } from '@/components/DataTable'
import type { AdminColumn } from '@/components/DataTable/types'
import { PERMISSIONS } from '@/lib/permissions'
import { fetchIncidents, SEC_STR as S, type IncidentRow } from './securityMoreApi'

/**
 * A18.09 — Инциденты безопасности. Reuses the LIVE A17 incident feed
 * (`GET /admin/incidents`) as the security-incident register. Read-only here;
 * full incident lifecycle lives under the A17 incidents module.
 */
export function IncidentsScreen() {
  const columns = useMemo<AdminColumn<IncidentRow>[]>(
    () => [
      { key: 'title', header: S.title, type: 'text' },
      {
        key: 'severity',
        header: S.severity,
        type: 'enum',
        width: 120,
        align: 'center',
        options: [
          { value: 'sev1', label: 'sev1', status: 'banned' },
          { value: 'sev2', label: 'sev2', status: 'blocked' },
          { value: 'sev3', label: 'sev3', status: 'pending' },
          { value: 'sev4', label: 'sev4', status: 'review' },
        ],
      },
      {
        key: 'status',
        header: S.status,
        type: 'enum',
        width: 150,
        options: [
          { value: 'open', label: S.openLbl, status: 'open' },
          { value: 'investigating', label: 'investigating', status: 'review' },
          { value: 'monitoring', label: 'monitoring', status: 'pending' },
          { value: 'resolved', label: 'resolved', status: 'active' },
        ],
      },
      { key: 'summary', header: S.summary, type: 'longtext', minWidth: 220 },
      { key: 'author', header: S.author, type: 'text', width: 150 },
      { key: 'started_at', header: S.startedAt, type: 'date', width: 150 },
    ],
    [],
  )
  const fetcher = useCallback(fetchIncidents, [])
  return (
    <>
      <PageHeader title={S.incidents} screenId="A18.09" />
      <DataTable<IncidentRow>
        screenId="A18.09"
        permission={PERMISSIONS.AUDIT_VIEW}
        columns={columns}
        fetcher={fetcher}
        rowId={(r) => String(r.id)}
        exportable
        emptyState={{ icon: <ShieldAlert size={28} strokeWidth={1.5} /> }}
      />
    </>
  )
}
